// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// android客户端打开webview的hack
if (window.location.hash.indexOf('pl=uplive') >= 0) {
  localStorage.setItem('__inuplive__', 1);
  window.location.replace(window.location.href.replace(window.location.hash, '#/index'));
}

import Vue from 'vue'
import './style/common.css'
import './global';
import App from './App'
import router from './router'
import promise from 'es6-promise';
import axios from 'axios'
import $ from 'zepto'
import FastClick from 'fastclick'
import './js/rem/index'
import './js/mUtils'
import './js/openjs/lib/zepto/callbacks'
import './js/openjs/lib/zepto/defered'
import './js/openjs/lib/zepto/fx'
import './js/openjs/h5'
import url from './js/plug/url'
import {setStore} from "./js/mUtils";

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function() {
    FastClick.attach(document.body);
  }, false);
}

const _platform = Uplib.native.getPlatform();
const _domain = document.domain;
let _system = Uplib.native.getSystem();

if (_domain == 'm.upliveapps.com' && _platform != 'uplive') {
  const targetURI = location.href.replace(_domain, 'h5.upliveapp.com');
  location.replace(targetURI);
}

window.SportLottery.payType = url.query('payType') || UpSDK.cache.getCache('payType') || 'GTO';
UpSDK.cache.setCache('payType', window.SportLottery.payType);

// 管理全局的销售渠道号
window.SportLottery.channel = url.query('channel') || '1';
window.gotUserTrigCount = 0;

if (_system == 'pc') {
  $(document.body).addClass('pcmode');
}


promise.polyfill();
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

// 保证无论在客户端还是在网页中
// 都可以获取到数美的设备号，便于做设备调用接口限制
let smDeviceId = UpSDK.cache.getCache('smDeviceId');
if (!smDeviceId) {
  UpSDK.getSMDeviceId();
}

let init = ()=>{
  // 如果在Uplive中，每次进入页面均需要重新登录
  // 同步客户端登录的最新账号信息
  if (_platform == 'uplive') {
    UpSDK.nativeLogin((data)=>{
      let loginObj = data || {};
      setStore('log',loginObj);
      renderDOM();
    });
  } else {
    renderDOM();
    // 获取用户信息
    UpSDK.getUser(function(data){
      let loginObj = data || {};
      setStore('log',loginObj);
      if (window.gotUserTrigCount === 1) {
        $.channel.emit('getUserSucc', data);
      } else {
        window.gotUserTrigCount++;
      }

    });
  }
};

let renderDOM = ()=>{
  new Vue({
    el: '#app',
    router,
    $,
    render: h => h(App)
  });
}

init();







// WEBPACK FOOTER //
// ./src/main.js